import { render, staticRenderFns } from "./UserPassword.vue?vue&type=template&id=53371a5b&scoped=true&"
import script from "./UserPassword.vue?vue&type=script&lang=js&"
export * from "./UserPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserPassword.vue?vue&type=style&index=0&id=53371a5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53371a5b",
  null
  
)

export default component.exports